// Most polyfills are handled by babel/core-js (see bundle/rules/babel.cjs)
// but some could not be handled this way

import { detectedEnv } from '#app/lib/env_config'

export async function initPolyfills () {
  if (detectedEnv === 'prod' && globalThis.window.visualViewport == null) {
    await import('#vendor/visual_viewport_polyfill')
  }
}

export const waitingForPolyfills = initPolyfills()
